import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'hcr-threshold-input',
  templateUrl: './threshold-input.component.html',
  styleUrls: ['./threshold-input.component.sass'],
})
export class ThresholdInputComponent implements OnChanges {
  @Input() value: number;
  @Input() maxValue: number;
  @Input() minValue: number;
  @Input() step: string | number;
  @Input() tooltip: string;
  @Input() label: string;
  @Output() public onChange = new EventEmitter<number>();
  @Output() public onInput = new EventEmitter<number>();

  public valueToShow: number;

  public icons = {
    questionCircle: faQuestionCircle,
  };

  public emitChangeValueEvent(): void {
    this.onChange.emit(this.value);
  }

  public emitInputEvent(): void {
    this.valueToShow = Number((this.value * 100).toFixed(0));
    this.onInput.emit(this.value);
  }

  public transformValueToShow(): void {
    this.value = this.valueToShow / 100;
    this.emitChangeValueEvent();
    this.emitInputEvent();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      if (this.value) {
        this.valueToShow = Number((this.value * 100).toFixed(0));
      } else {
        this.valueToShow = 0;
      }
    }
  }
}
